import { Constants } from "./constants";

export var GoogleUtils = {
    getGeocodeRequestUrl: function (key, address) {        return `${Constants.GOOGLE.GEOCODE.URL}?language=en&${Constants.GOOGLE.GEOCODE.PARAMETERS.KEY}=${key}&${Constants.GOOGLE.GEOCODE.PARAMETERS.ADDRESS}=${address}`;    },    extractGeocodeLocationDetails: function (response) {
        if (!response)
            return null;

        if (!Array.isArray(response.results))
            return null;

        if (response.results.length === 0)
            return null;

        var firstResult = response.results[0];
        if (!firstResult)
            return null;

        if (!firstResult.geometry)
            return null;

        if (!firstResult.geometry.location)
            return null;

        var locationDetails = {};

        if (!firstResult.geometry.location.lat)
            return null;

        locationDetails.latitude = firstResult.geometry.location.lat;

        if (!firstResult.geometry.location.lng)
            return null;

        locationDetails.longitude = firstResult.geometry.location.lng;

        if (!Array.isArray(firstResult.address_components))
            return null;

        var stateAddressComponent = firstResult.address_components.find(component => component.types.some(type => type === "administrative_area_level_1"));
        if (!stateAddressComponent)
            return null;

        if (!stateAddressComponent.short_name)
            return null;

        locationDetails.stateCode = stateAddressComponent.short_name;
        locationDetails.stateName = stateAddressComponent.long_name || "";

        return locationDetails;
    }}